import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../lib/constants';
const Unauthorized = () => {
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const source = axios.CancelToken.source();

    const checkAccess = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/access_add_user`, {

          withCredentials: true,  // send cookies automatically
          cancelToken: source.token,
        });
        if (response.status === 200 && response.data.status === 'success') {
         
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          setError(err.response?.data?.message || err.message || 'Access check failed');
          console.error("Access check error:", err);
          setHasAccess(false);
        }
      } finally {
        setLoading(false);
      }
    };

    checkAccess();

    return () => {
      source.cancel('Request cancelled on component unmount');
    };
  }, [navigate]);

  useEffect(() => {
    if (!loading && hasAccess) {
      navigate('/addUser');
    }
  }, [loading, hasAccess, navigate]);

  useEffect(() => {
    if (!loading && !hasAccess) {
      // Redirect to login after 3 seconds if no access
      const timer = setTimeout(() => navigate('/'), 3000);
      return () => clearTimeout(timer);
    }
  }, [loading, hasAccess, navigate]);

  if (loading) return <p>Checking access...</p>;

  return (
    <div style={{ padding: 20, textAlign: "center" }}>
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      <p>Redirecting to login...</p>
    </div>
  );
};

export default Unauthorized;
